const viewConsentColumns = [
  { field: 'consentPurpose', header: 'Consent Purpose' },
  { field: 'consentFetchType', header: 'Fetch Type' },
];

export default viewConsentColumns;
